var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("g", [
    _c("defs", [
      _c("path", {
        attrs: {
          id: "car-temp@1x-a",
          d:
            "M12.4850618,18.2571707 C12.4850618,18.5248358 12.267315,18.7417219 11.99965,18.7417219 C11.731985,18.7417219 11.5142382,18.5248358 11.5142382,18.2571707 C11.5142382,17.988645 11.731985,17.7717589 11.99965,17.7717589 C12.267315,17.7717589 12.4850618,17.988645 12.4850618,18.2571707 L12.4850618,18.2571707 Z M12.0030926,8.03770261 L12.0013713,8.03770261 C11.5693204,8.03770261 11.2164501,8.38971225 11.2164501,8.82348452 L11.2155894,13.7025619 C10.4341108,13.7912098 9.68447658,14.0080959 8.9804573,14.348917 L4.22101156,7.73388989 C4.60314428,7.50323321 5.00076886,7.28634707 5.40700003,7.08667412 L6.13683909,8.44909774 L7.51819721,7.70893077 L6.85376825,6.47130275 C7.28667986,6.31294145 7.73078005,6.1743753 8.17660154,6.05732564 L8.46750438,7.3956508 L9.99861721,7.06171501 L9.71115701,5.74060303 C10.2094787,5.66400436 10.7138251,5.61322546 11.2155894,5.58740568 L11.2155894,6.91454227 L12.7828499,6.91454227 L12.7828499,5.58740568 C13.277729,5.61322546 13.7743294,5.6631437 14.2640445,5.73629974 L13.974863,7.06171501 L15.5068365,7.3956508 L15.7994607,6.05130103 C16.2435608,6.16749003 16.6885217,6.30519551 17.1248759,6.46441748 L16.4561437,7.70893077 L17.8375018,8.44909774 L18.5725048,7.07806753 C18.981318,7.27687982 19.3849672,7.49720859 19.7774278,7.73475055 L15.017982,14.348917 C14.3148234,14.0080959 13.5669105,13.7920705 12.7897352,13.7034226 L12.7897352,8.82348452 C12.7897352,8.38971225 12.4360042,8.03770261 12.0030926,8.03770261 L12.0030926,8.03770261 Z M21.335221,6.8758126 C18.5768081,4.99441145 15.3484752,4.00035 11.99965,4.00035 C8.64996414,4.00035 5.42163124,4.99441145 2.66321829,6.87495195 L1.99965,7.32765872 L8.54238173,16.4222452 L9.16463838,16.0340878 C9.78517371,15.6476518 10.4909143,15.3894541 11.2155894,15.2827323 L11.2155894,16.3611384 C10.451324,16.6761397 9.94783831,17.4188886 9.94783831,18.2563101 C9.94783831,19.388077 10.8678831,20.3089824 11.99965,20.3089824 C13.1314169,20.3089824 14.0514617,19.388077 14.0514617,18.2563101 C14.0514617,17.4188886 13.547976,16.6761397 12.7828499,16.3611384 L12.7828499,15.2827323 C13.5083857,15.3894541 14.2141263,15.6476518 14.8346616,16.0340878 L15.4569183,16.4222452 L21.99965,7.32765872 L21.335221,6.8758126 Z"
        }
      })
    ]),
    _vm._v(" "),
    _c("g", { attrs: { fill: "none", "fill-rule": "evenodd" } }, [
      _c("rect", {
        staticStyle: { "mix-blend-mode": "color-burn" },
        attrs: {
          width: "24",
          height: "24",
          fill: "#E3E3E3",
          "fill-opacity": ".01"
        }
      }),
      _vm._v(" "),
      _c("use", {
        attrs: {
          fill: _vm.currentColor,
          opacity: _vm.opacity,
          "xlink:href": "#car-temp@1x-a"
        }
      })
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }